import Vue from 'vue';
import * as _ from 'lodash'


export default (azCode:string):string => {
    let lastCode = _.last(azCode) || '';
    let codes:{[k:string]:string} = {
        a: Vue.$trans('可用区A'),
        b: Vue.$trans('可用区B'),
        c: Vue.$trans('可用区C'),
        d: Vue.$trans('可用区D'),
        e: Vue.$trans('可用区E'),
    }
    return codes[lastCode] || azCode;
}

// export default {
//     'cn-beijing-6a': Vue.$trans('可用区A'),
//     'cn-beijing-6b': Vue.$trans('可用区B'),
//     'cn-beijing-6c': Vue.$trans('可用区C'),
//     'cn-beijing-6d': Vue.$trans('可用区D'),
//     'cn-hongkong-2a': Vue.$trans('可用区A'),
//     'cn-hongkong-2b': Vue.$trans('可用区B'),
//     'cn-shanghai-2a': Vue.$trans('可用区A'),
//     'cn-shanghai-2b': Vue.$trans('可用区B'),
//     'cn-shanghai-3a': Vue.$trans('可用区A'),
//     'cn-shanghai-3b': Vue.$trans('可用区B'),
//     'cn-beijing-1-newa': Vue.$trans('可用区A'),
//     'cn-beijing-1-newb': Vue.$trans('可用区B'),
//     'ap-singapore-1a': Vue.$trans('可用区A'),
//     'ap-singapore-1b': Vue.$trans('可用区B'),
//     'cn-guangzhou-1a': Vue.$trans('可用区A'),
//     'cn-wuhan-1a': Vue.$trans('可用区A'),
//     'eu-east-1a': Vue.$trans('可用区A'),
//     'eu-east-1b': Vue.$trans('可用区B'),
//     'cn-taipei-1a': Vue.$trans('可用区A'),
//     'cn-qingdao-1a': Vue.$trans('可用区A'),
//     'cn-beijing-fin-a': Vue.$trans('可用区A'),
//     'cn-shanghai-fin-a': Vue.$trans('可用区A'),
//     'cn-north-1-gov-a': Vue.$trans('可用区A'),
//     'cn-qingdaodev-1a': Vue.$trans('可用区A'),
//     'cn-central-1a': Vue.$trans('可用区A')
// }
